import { render, staticRenderFns } from "./GroupBuyIndex.vue?vue&type=template&id=2235f9c5&scoped=true"
import script from "./GroupBuyIndex.vue?vue&type=script&lang=js"
export * from "./GroupBuyIndex.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyIndex.vue?vue&type=style&index=0&id=2235f9c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235f9c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2235f9c5')) {
      api.createRecord('2235f9c5', component.options)
    } else {
      api.reload('2235f9c5', component.options)
    }
    module.hot.accept("./GroupBuyIndex.vue?vue&type=template&id=2235f9c5&scoped=true", function () {
      api.rerender('2235f9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/group_buy/GroupBuyIndex.vue"
export default component.exports